import { render } from "./BatchesWaitingBalanceTotals.vue?vue&type=template&id=b41f4d1c"
import script from "./BatchesWaitingBalanceTotals.vue?vue&type=script&lang=js"
export * from "./BatchesWaitingBalanceTotals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__